"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "pbkdf2", {
  enumerable: true,
  get: function get() {
    return _pbkdf.pbkdf2;
  }
});
Object.defineProperty(exports, "pbkdf1", {
  enumerable: true,
  get: function get() {
    return _pbkdf.pbkdf1;
  }
});
exports.default = void 0;

var _pbkdf = require("./pbkdf.js");

/**
 * index.js
 */
var _default = {
  pbkdf2: _pbkdf.pbkdf2,
  pbkdf1: _pbkdf.pbkdf1
}; // both export and export default needs to be declared for compatibility on node and browser.

exports.default = _default;